import { render, staticRenderFns } from "./TrucksTotalsList.vue?vue&type=template&id=00664240"
import script from "./TrucksTotalsList.vue?vue&type=script&lang=js"
export * from "./TrucksTotalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports